<div [formGroup]="fg()">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.confirmationMode.description' | labelsProvider }}
    </div>

    <mat-radio-group [value]="confirmationMode()" (change)="onRadioButtonChange($event.value)">
      <div class="radio-option">
        <mat-radio-button [value]="confirmationModeEnum.strict">
          {{ 'commonActions.confirmationMode.strictModeTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.confirmationMode.strictModeDescription' | labelsProvider }}
        </div>
      </div>

      <div class="radio-option">
        <mat-radio-button [value]="confirmationModeEnum.disabled">
          {{ 'commonActions.confirmationMode.disabledModeTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.confirmationMode.disabledModeDescription' | labelsProvider }}
        </div>
      </div>
    </mat-radio-group>
  </div>

  <app-autonomous-with-triggers
    [fg]="fg()"
    [(ignoreIfAutonomousWithTriggers)]="ignoreIfAutonomousWithTriggers"
    [labelKey]="getLabelKey()"
  ></app-autonomous-with-triggers>
</div>
